export const PERK = {
  // General messages
  START_DATE_REQUIRED:
    'Display From Date is required when perk is not always displayed.',
  END_DATE_GREATER:
    'Display Until Date should be greater than Display From Date.',
  USER_REQUIRED: 'User is required.',
  INVALID_NAME: "'Perks' as a name is not allowed.",
  NOT_FOUND: 'Page not found.',
  NOT_AVAILABLE: 'Perk not available.',
  ACCEPT_TERMS: 'Please accept the terms and conditions.',
  CREATED: 'Perk created.',
  UPDATED: 'Perk updated.',
  EDIT_UNPUB_IN_CAROUSEL:
    'Perk updated. Users will not be able to view this unpublished perk in the carousel.',
  STATUS_UPDATED: 'Perk status updated.',
  DELETED: 'Perk deleted.',

  // Validation errors
  PROVIDE_PRICE_FOR_PURCHASABLE:
    'Please provide a price to make this perk purchasable.',
  INVALID_PRICE: 'Please provide valid price.',
  REMAINING_QUANTITY_REQUIRED: 'Remaining quantity is required.',
  INVALID_REMAINING_QUANTITY: 'Please provide valid remaining quantity.',
  INVALID_MAX_ALLOWED_PER_USER:
    'Please provide valid max allowed per user value.',
  INVALID_ALLOWED_PER_USER: 'Please provide valid per user value.',
  INVALID_ALLOWED_EVERY_DAY: 'Please provide valid every day(s) value.',
  START_DATE_SHOULD_LESS_THEN_END_DATE:
    'Perk display from date cannot be after the display until date.',
  START_DATE_OR_ALWAYS_AVAILABLE_REQUIRED:
    'Please provide display from date or check "Always Display" box.',
  REDEEM_LIMIT_EXCEEDED_PROVIDED_CODES:
    'Remaining quantity cannot be greater than provided redeem codes.',

  // Redeem code errors
  REDEEM_CODE_COPIED: 'Code copied to clipboard.',
  REDEEM_CODE_DUPLICATE: 'Redeem Code already available.',
  REDEEM_CODE_DUPLICATE_IN_ALL_PERKS:
    'Redeem Code already available in other perk.',
  REDEEM_CODE_SPACE: 'Redeem Code cannot contain white spaces.',
  REDDEM_CODES_REQUIRED:
    'You need to add your redeem codes, or you can select to have us automatically create redeem codes for you.',
  MAX_USER_REDEEM_LIMIT_EXCEEDED:
    'Your allowance has been reached, try again later.',

  // Constraints and limitations
  LIMITS_NOT_ALLOWED:
    'Limits/Constraints can’t be implemented without "Use Redeem Codes".',
  DISCOUNT_CODE_NOT_ALLOWED:
    'Discount code is not allowed with these controls selection made (Purchasable, Use Redeem Codes, Total Quantity Available, Max Allowed Per User/Days).',

  // Permission errors
  DESCRIPTION_PERMISSION_ERROR_MESSAGE:
    'You do not have permission to add a description to this perk. Please contact your administrator for assistance.',
  IMAGE_PERMISSION_ERROR_MESSAGE:
    'You do not have permission to add an image to this perk. Please contact your administrator for assistance.',
  CATEGORY_PERMISSION_ERROR_MESSAGE:
    'You do not have permission to assign a category to this perk. Please contact your administrator for assistance.',
  LOGO_PERMISSION_ERROR_MESSAGE:
    'You do not have permission to add a logo image to this perk. Please contact your administrator for assistance.',
  GROUP_PERMISSION_ERROR_MESSAGE:
    'You do not have permission to modify the user selector for this perk. Please contact your administrator for assistance.',
  CONTACT_PERMISSION_ERROR_MESSAGE:
    'You do not have permission to add contact information (name, website, phone number) to this perk. Please contact your administrator for assistance.',
  DISPLAY_SCHEDULE_PERMISSION_ERROR_MESSAGE:
    'You do not have permission to modify the display schedule settings. Please contact your administrator for assistance.',
  DISCOUNT_PERMISSION_ERROR_MESSAGE:
    'You are not authorized to set discounts. Please contact your administrator if you need this permission.',
  PURCHASABLE_PERMISSION_ERROR_MESSAGE:
    'You do not have the required permissions to modify the purchasable options or set a price. Contact your administrator for help.',
  LIMITS_CONSTRAINTS_PERMISSION_ERROR_MESSAGE:
    'You are not permitted to modify limits or constraints for this perk. Please reach out to your administrator for further assistance.',
  CODES_PERMISSION_ERROR_MESSAGE:
    'You do not have permission to manage redeem codes for this perk. Contact your administrator for permission.',
  REGISTER_INTEREST_PERMISSION_ERROR_MESSAGE:
    "You are not authorized to manage the 'Register Interest'. Please reach out to your administrator for assistance.",
  LOCATIONS_PERMISSION_ERROR_MESSAGE:
    'You do not have permission to add or modify locations. Contact your administrator for further help.',

  // Other messages
  PERK_CREATE_LIMIT_REACHED: (perkCreateLimit: number): string =>
    `You are not allowed to create more than ${perkCreateLimit} perk${
      perkCreateLimit > 1 ? 's' : ''
    } right now. Contact admin to increase your limit and try again later.`,
  VERIFY_PERK_REDEEM_ERROR: 'Error occurred while verifying perk redeem.',
  INVALID_STATUS:
    "Cannot send a notification while the perk is in Draft mode. You'll need to Publish it first.",
  NOTIFICATION_ON_UNPUBLISH:
    'Cannot send a notification, while trying to unpublish a perk.',
  PERK_WEBSITE_OPEN_ERROR:
    'Error occurred while trying to open the perk website URL.',

  // Descriptive messages
  FOR_USERS: 'Select the organisations that can avail of your perk.',
  FOR_USERS_PREVIEW:
    'Allow your perk to be previewed by Companies and Colleges, before connecting with them.',
  LEGEND_STUDENT_DESC:
    'The graduate cap represents a connected College, their <b>Students</b> will see your perk 👩🏾‍🎓👨‍🎓',
} as const;

export const GIVE_PERKS = {
  TRANSACTION_PROCESS: 'Transaction is processing.',
} as const;

export const PERK_CLICK = {
  CAPTURED: 'Perk Click captured.',
} as const;

export const VERIFY_PERK_REDEEM = {
  FOUND: 'Perk redeem code found.',
  NOT_FOUND: 'Perk redeem code not found.',
  CODE_CREATED: 'Code created successfully.',
  UPDATED: 'Perk redeem updated.',
} as const;

export const PERK_INTEREST = {
  ADDED: 'Perk interest registered.',
  REMOVED: 'Perk interest unregistered.',
  NOT_FOUND: 'Interest not registered for this perk.',
  DUPLICATE: 'Perk interest already registered.',
} as const;
